import { render } from "./graficas.vue?vue&type=template&id=7532fcbe&scoped=true"
import script from "./graficas.vue?vue&type=script&lang=js"
export * from "./graficas.vue?vue&type=script&lang=js"

import "./graficas.vue?vue&type=style&index=0&id=7532fcbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7532fcbe"]])

export default __exports__